import { message, Typography, Row } from "antd";
import TextField from "./TextField";
import PasswordField from "./PasswordField";
import MobileField from "./MobileField";
import { updateAccountDetails, updateMobileNumber } from "api/customApis";

const { Title } = Typography;
export default function AccountDetails({ countryCodes, data, fetchData }) {
	const updateText = (d, callback, label) => {
		updateAccountDetails(data.id, { [d.fieldId]: d.fieldValue })
			.then((res) => {
				callback(d.fieldValue);
				if (label) {
					message.success(`${label} updated successfully`);
				}
				fetchData();
			})
			.catch(() => {
				message.error(`Failed to update ${d.fieldId}`);
			});
	};


	return (
		<div>
			<Row>
				{" "}
				<Title level={5} type="secondary">
					ACCOUNT DETAILS
				</Title>{" "}
			</Row>
			<TextField
				updateText={updateText}
				label="First Name"
				value={data?.first_name}
				fieldId="first_name"
				editable
			/>
			<TextField
				updateText={updateText}
				label="Last Name"
				value={data?.last_name}
				fieldId="last_name"
				editable
			/>
			<TextField label="Email" value={data.email} />

			<MobileField
				label="Contact Number (OTP will be sent to this number)"
				editable
				countryCodes={countryCodes}
				mobile={data.mobile}
				country={data.country}
				email={data.email}
				fetchData={fetchData}
			/>

			<PasswordField
				userId={data.id}
				value={data.password}
				email={data.email}
			/>
		</div>
	);
}
